module.exports = __webpack_public_path__ + "img/hamburger.dc9d01fc.svg";